import Table from "react-bootstrap/Table";

import { RiskClassification } from "@/@types/sintegrada/RiskClassification";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { timeToString } from "@/utils/dateUtil";

type Props = {
	averageTimeInSecondsByRiskClassification: ResumeGrouped<RiskClassification, object>[];
};

export function AverageDurationOfAttandanceTable({
	averageTimeInSecondsByRiskClassification,
}: Props) {
	return (
		<Table className="text-center" responsive striped bordered hover>
			<thead>
				<tr className="fw-bolder">
					<th className="ps-2 text-start">Classificação</th>
					<th className="pe-2">Tempo médio de duração do atendimento</th>
				</tr>
			</thead>
			<tbody>
				{averageTimeInSecondsByRiskClassification.map((aggregated, index) => (
					<tr key={`wait-time-risk-classification-table-row-${index}`}>
						<td className="ps-2 text-start">
							<span
								style={{
									color: aggregated.key?.color || "#6c757d",
									fontWeight: "bold",
								}}
							>
								{aggregated.key?.name || "Não informado"}
							</span>
						</td>
						<td className="pe-2">{timeToString(aggregated.total)}</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
